import { jsxs as g, jsx as r } from "react/jsx-runtime";
import { QUERIES as b } from "@fcamna/shared-component-foundations";
import { useRef as H, useMemo as _, useState as W, useEffect as w } from "react";
import s from "styled-components";
import { u as U } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Icon as v } from "./icon.js";
import { Image as P } from "./image.js";
import { ModalWindow as O, ModalHeader as K, ModalBody as Q } from "./modalWindow.js";
import { S as V } from "./screenReaderOnly-fd82ed96.mjs";
import { u as B } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as q } from "./useWindowDimensions-ae69e913.mjs";
import "@fcamna/shared-icons";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useClient-0bbce34e.mjs";
import "./Aria-f5e019e2.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./disclosure.js";
import "./focusTrap.js";
import "./hTag-27bb1617.mjs";
import "./index-5d51183d.mjs";
import "./tslib.es6-59e1c9d8.mjs";
const C = s.div`
  position: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.position};
  display: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.display};
  width: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.width};
  flex-direction: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.flexDirection};
  justify-content: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.justifyContent};
  align-items: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.alignItems};
  align-self: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.alignSelf};
  border-radius: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.borderRadius};
  background: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.background};
  gap: ${(o) => o.theme.components.photoGalleryLightbox.MainWrapper.gap};
`, J = s.div`
  position: ${(o) => o.theme.components.photoGalleryLightbox.ImgWrapper.position};
  width: ${(o) => o.theme.components.photoGalleryLightbox.ImgWrapper.width};
  background: ${(o) => o.theme.components.photoGalleryLightbox.ImgWrapper.background};
`, X = s.div`
  display: ${(o) => o.theme.components.photoGalleryLightbox.ContaintWrapper.display};
  padding: ${(o) => o.theme.components.photoGalleryLightbox.ContaintWrapper.padding};
  flex-direction: ${(o) => o.theme.components.photoGalleryLightbox.ContaintWrapper.flexDirection};
  align-items: ${(o) => o.theme.components.photoGalleryLightbox.ContaintWrapper.alignItems};
  align-self: ${(o) => o.theme.components.photoGalleryLightbox.ContaintWrapper.alignSelf};
  gap: ${(o) => o.theme.components.photoGalleryLightbox.ContaintWrapper.gap};
  @media ${b.tabletAndUp} {
    padding: ${(o) => o.theme.components.photoGalleryLightbox.ContaintWrapper.tabletAndUp.padding};
  }
`, Y = s.div`
  color: ${(o) => o.theme.components.photoGalleryLightbox.TitleWrapper.color};
  font-family: ${(o) => o.theme.components.photoGalleryLightbox.TitleWrapper.fontFamily};
  font-size: ${(o) => o.theme.components.photoGalleryLightbox.TitleWrapper.fontSize};
  font-style: ${(o) => o.theme.components.photoGalleryLightbox.TitleWrapper.fontStyle};
  font-weight: ${(o) => o.theme.components.photoGalleryLightbox.TitleWrapper.fontWeight};
  line-height: ${(o) => o.theme.components.photoGalleryLightbox.TitleWrapper.lineHeight};
`, Z = s.div`
  width: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.width};
  font-family: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontFamily};
  font-size: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontSize};
  font-style: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontStyle};
  font-weight: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontWeight};
  line-height: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.lineHeight};
  color: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.color};
  align-self: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.alignSelf};
  overflow: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.overflow};
  text-overflow: ${(o) => o.theme.components.photoGalleryLightbox.DescriptionWrapper.textOverflow};
`, I = s.div`
  display: ${(o) => o.theme.components.photoGalleryLightbox.ImageCount.display};
  width: ${(o) => o.theme.components.photoGalleryLightbox.ImageCount.width};
  align-items: ${(o) => o.theme.components.photoGalleryLightbox.ImageCount.alignItems};
  justify-content: ${(o) => o.theme.components.photoGalleryLightbox.ImageCount.justifyContent};
`, M = s.button`
  position: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.position};
  z-index: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.zIndex};

  top: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.top};
  ${(o) => o.$flag === "left" ? o.theme.components.photoGalleryLightbox.NavButton.flag.left : o.theme.components.photoGalleryLightbox.NavButton.flag.default}

  height: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.height};
  width: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.width};
  display: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.display};
  align-items: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.alignItems};
  justify-content: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.justifyContent};
  border: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.border};
  border-radius: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.borderRadius};
  cursor: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.cursor};
  background-color: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.backgroundColor};
  color: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.color};

  &:not(&--disabled):focus-visible {
    outline: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.focusVisible.outline};
    outline-offset: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.focusVisible.outlineOffset};
  }

  &:disabled {
    cursor: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.disabled.cursor};
    color: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.disabled.color};
  }

  &:hover:not(&--disabled) {
    background-color: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.hover.backgroundColor};
    color: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.hover.color};
  }

  @media ${b.mobile} {
    display: ${(o) => o.theme.components.photoGalleryLightbox.NavButton.mobile.display};
  }
`, oo = s(O)`
  padding: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.padding} !important;
  box-shadow: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.boxShadow}!important;
  border-radius: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.borderRadius}!important;
  &.ModalWindow__container {
    max-height: none;
  }
  .ModalWindow__body {
    max-height: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.modalWindowBody.maxHeight};
    padding: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.modalWindowBody.padding};
    margin: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.modalWindowBody.margin};
  }
  @media ${b.tabletAndUp} {
    padding: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.tabletAndUp.padding} !important;
  }
  @media ${b.mobile} {
    border-radius: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.mobile.borderRadius}!important;
    min-width: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.mobile.minWidth}!important;
    height: ${({ $hasContentInImages: o }) => o ? "100%" : "auto"} !important;
    .ModalWindow__content {
      gap: ${(o) => o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.mobile.gap} !important;
    }
  }
`, to = s.div`
  font-size: ${(o) => {
  var i, l, h, a;
  return (a = (h = (l = (i = o == null ? void 0 : o.theme) == null ? void 0 : i.components) == null ? void 0 : l.photoGalleryLightbox) == null ? void 0 : h.Disclosures) == null ? void 0 : a.fontSize;
}};
  font-family: ${(o) => {
  var i, l, h, a;
  return (a = (h = (l = (i = o == null ? void 0 : o.theme) == null ? void 0 : i.components) == null ? void 0 : l.photoGalleryLightbox) == null ? void 0 : h.Disclosures) == null ? void 0 : a.fontFamily;
}};
  font-weight: ${(o) => {
  var i, l, h, a;
  return (a = (h = (l = (i = o == null ? void 0 : o.theme) == null ? void 0 : i.components) == null ? void 0 : l.photoGalleryLightbox) == null ? void 0 : h.Disclosures) == null ? void 0 : a.fontWeight;
}};
  line-height: ${(o) => {
  var i, l, h, a;
  return (a = (h = (l = (i = o == null ? void 0 : o.theme) == null ? void 0 : i.components) == null ? void 0 : l.photoGalleryLightbox) == null ? void 0 : h.Disclosures) == null ? void 0 : a.lineHeight;
}};
  color: ${(o) => {
  var i, l, h, a;
  return (a = (h = (l = (i = o == null ? void 0 : o.theme) == null ? void 0 : i.components) == null ? void 0 : l.photoGalleryLightbox) == null ? void 0 : h.Disclosures) == null ? void 0 : a.color;
}};
  padding-top: ${(o) => {
  var i, l, h, a;
  return (a = (h = (l = (i = o == null ? void 0 : o.theme) == null ? void 0 : i.components) == null ? void 0 : l.photoGalleryLightbox) == null ? void 0 : h.Disclosures) == null ? void 0 : a.paddingTop;
}};
`, eo = s(K)`
  @media ${b.mobile} {
    padding: ${(o) => {
  var i, l, h;
  return (h = (l = (i = o == null ? void 0 : o.theme) == null ? void 0 : i.components) == null ? void 0 : l.photoGalleryLightbox) == null ? void 0 : h.StyledModalHeader.mobile.padding;
}};
  }
`;
function io(o) {
  for (const i of o)
    if (i.title || i.description || i.disclosureContent)
      return !0;
  return !1;
}
function Eo({
  images: o = [],
  onClose: i,
  className: l,
  autoImageChange: h,
  isOpen: a,
  imageInterval: D = 3e3,
  activeIndex: y = 1,
  accessibilityOptions: j = {},
  separator: x = "of"
}) {
  const k = U({ label: "Photo Gallery Lightbox" }), c = H(null), { width: u } = q(), G = _(() => io(o), []), [p, d] = W(y), [n, f] = W({
    id: 1,
    src: "",
    alt: "",
    title: "",
    description: "",
    disclosureContent: "",
    objectFit: "cover",
    ratio: "16/9"
  }), {
    prevButton: S,
    nextButton: T,
    closeButton: F
  } = j, A = B("button", {
    ariaLabel: "previous",
    ...S
  }), N = B("button", {
    ariaLabel: "next",
    ...T
  }), m = o == null ? void 0 : o.length, L = () => {
    if (p >= 1) {
      const e = p === 1 ? m : p - 1, t = o[e - 1];
      f({
        id: (t == null ? void 0 : t.id) || e,
        src: (t == null ? void 0 : t.src) || "",
        alt: (t == null ? void 0 : t.alt) || "",
        title: (t == null ? void 0 : t.title) || "",
        description: (t == null ? void 0 : t.description) || "",
        disclosureContent: (t == null ? void 0 : t.disclosureContent) || "",
        objectFit: (t == null ? void 0 : t.objectFit) || "cover",
        ratio: (t == null ? void 0 : t.ratio) || "16/9"
      }), d(e);
    }
  }, $ = () => {
    if (p <= m) {
      const e = p === m ? 1 : p + 1, t = o[e - 1];
      f({
        id: (t == null ? void 0 : t.id) || e,
        src: (t == null ? void 0 : t.src) || "",
        alt: (t == null ? void 0 : t.alt) || "",
        title: (t == null ? void 0 : t.title) || "",
        description: (t == null ? void 0 : t.description) || "",
        disclosureContent: (t == null ? void 0 : t.disclosureContent) || "",
        objectFit: (t == null ? void 0 : t.objectFit) || "cover",
        ratio: (t == null ? void 0 : t.ratio) || "16/9"
      }), d(e);
    }
  }, z = (e) => {
    u > 599 || (c.current = e.touches[0].clientX);
  }, R = (e) => {
    c.current !== null && (u > 599 || ((c == null ? void 0 : c.current) - e.changedTouches[0].clientX > 50 ? $() : e.changedTouches[0].clientX - (c == null ? void 0 : c.current) > 50 && L()));
  };
  return w(() => {
    const e = o[p - 1];
    if (f({
      id: (e == null ? void 0 : e.id) || p,
      src: (e == null ? void 0 : e.src) || "",
      alt: (e == null ? void 0 : e.alt) || "",
      title: (e == null ? void 0 : e.title) || "",
      description: (e == null ? void 0 : e.description) || "",
      disclosureContent: (e == null ? void 0 : e.disclosureContent) || "",
      objectFit: (e == null ? void 0 : e.objectFit) || "cover",
      ratio: (e == null ? void 0 : e.ratio) || "16/9"
    }), h && a) {
      if (p <= m) {
        const t = setInterval(() => {
          const E = p % m + 1;
          d(E);
        }, D);
        return () => clearInterval(t);
      }
      d(1);
    }
  }, [p, a]), w(() => {
    d(y);
  }, [y]), (o == null ? void 0 : o.length) > 0 ? /* @__PURE__ */ g(
    oo,
    {
      "data-wrapper": "PhotoLightboxModelWindow",
      variant: "large",
      isOpen: a,
      onClose: () => i == null ? void 0 : i((n == null ? void 0 : n.id) ?? 1),
      bgOverlayColor: "rgba(0, 20, 46, 0.30)",
      $hasContentInImages: G,
      ...k,
      children: [
        /* @__PURE__ */ r(
          eo,
          {
            hasClose: !0,
            onClose: () => i == null ? void 0 : i((n == null ? void 0 : n.id) ?? 1),
            accessibilityOptions: F
          }
        ),
        /* @__PURE__ */ r(Q, { children: /* @__PURE__ */ g(C, { className: l, children: [
          /* @__PURE__ */ g(J, { children: [
            /* @__PURE__ */ r(
              M,
              {
                tabIndex: 0,
                onClick: L,
                ...A,
                onKeyDown: (e) => {
                  (e.key === "Enter" || e.key === " ") && (e.preventDefault(), L());
                },
                $flag: "left",
                children: /* @__PURE__ */ r(v, { name: "caretLeft" })
              }
            ),
            /* @__PURE__ */ r(
              P,
              {
                src: n == null ? void 0 : n.src,
                alt: n == null ? void 0 : n.alt,
                onTouchStart: z,
                onTouchEnd: R,
                ratio: n == null ? void 0 : n.ratio,
                objectFit: n == null ? void 0 : n.objectFit
              }
            ),
            /* @__PURE__ */ r(
              M,
              {
                tabIndex: 0,
                onClick: $,
                onKeyDown: (e) => {
                  (e.key === "Enter" || e.key === " ") && (e.preventDefault(), $());
                },
                ...N,
                $flag: "right",
                children: /* @__PURE__ */ r(v, { name: "caretRight" })
              }
            )
          ] }),
          /* @__PURE__ */ r(V, { "aria-live": "assertive", children: `${p} ${x} ${m} ${n == null ? void 0 : n.alt}` }),
          /* @__PURE__ */ r(I, { style: { alignItems: "center" }, children: `${p} ${x} ${m}` }),
          G && /* @__PURE__ */ g(X, { children: [
            /* @__PURE__ */ r(Y, { children: n == null ? void 0 : n.title }),
            /* @__PURE__ */ r(Z, { children: n == null ? void 0 : n.description }),
            /* @__PURE__ */ r(to, { children: n == null ? void 0 : n.disclosureContent })
          ] })
        ] }) })
      ]
    }
  ) : null;
}
export {
  Eo as PhotoGalleryLightbox
};
